import { ModalId } from '../../../../../enums/modalId'

export const getAttachmentPreviewModalId = (attachmentId: string): string =>
  `${ModalId.AttachmentPreviewModal}-${attachmentId}`
